import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { getInsensitiveSearchParams } from "@/lib/get-insensitive-search-params"

const sleep = (delay: number) => new Promise<void>((resolve) => setTimeout(resolve, delay))

const hinLoginPage = "https://apps.hin.ch/"

const LoggedHinEpd = () => {
  const { t } = useTranslation()
  const [success, setSuccess] = useState(true)

  useEffect(() => {
    const sendMessage = async () => {
      const params = new URLSearchParams(window.location.search)
      const isFailedDueToSsoGatewayUser = getInsensitiveSearchParams(params, "hin-sso-gateway-user").exists

      if (window.opener) {
        const action = isFailedDueToSsoGatewayUser ? "hin-epd-failed-sso-gateway-user" : "hin-epd-logged"
        window.opener.postMessage({ action }, `${window.location.origin}/patients`)
      }

      if (isFailedDueToSsoGatewayUser) {
        setSuccess(false)
        await sleep(10000)
        window.location.href = hinLoginPage
      } else {
        window.close()
      }
    }

    sendMessage()
  }, [])

  const handleCloseButtonClick = () => {
    window.close()
  }

  return success ? (
    <div className="flex h-screen flex-col items-center justify-center">
      <p className="text-success mb-4 text-2xl font-bold">{t("hin.loginHinSuccessfully")}</p>
      <Button variant="secondary" onClick={handleCloseButtonClick}>
        {t("common.button.close")}
      </Button>
    </div>
  ) : (
    <div className="flex h-screen flex-col items-center justify-center">
      <p className="text-on-surface-subdued mb-4 text-2xl font-bold">{t("hin.epd.failedDueToSsoGatewayUser.title")}</p>
      <p className="text-critical mb-4 text-2xl font-bold underline">
        <a href={hinLoginPage}>{t("hin.epd.failedDueToSsoGatewayUser.manuallyProceed")}</a>
      </p>
      <p className="text-on-surface-subdued mb-4 text-2xl font-bold">
        {t("hin.epd.failedDueToSsoGatewayUser.autoProceed")}
      </p>
    </div>
  )
}

export { LoggedHinEpd }
